import { Select } from "antd";
import i18 from "i18next";
import * as React from "react";
import { getGlobalParams } from "src/common/globalParams";
import { makeRef } from "src/common/makeRef";
import { LogoIcon } from "src/icons/LogoIcon";
import { langList } from "src/lang/langList";

import * as styles from "./CommonOverlay.module.less";

interface PropsCommonOverlay {
  children?: React.ReactNode;
  title?: string;
}

export const CommonOverlay: React.FC<PropsCommonOverlay> = ({
  children,
  title,
}) => (
  <div className={styles.loginPage}>
    <div className={styles.formContainer}>
      <div className={styles.langDiv}>
        <Select
          className={styles.langSelect}
          defaultValue={i18.language}
          options={langList}
          onChange={(langOption) => {
            window.location.href = makeRef(window.location.href, langOption);
          }}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.logo}>
          <LogoIcon />
          <span className={styles.logoText}>{getGlobalParams().title}</span>
        </div>
        <div className={styles.title}>{title}</div>
        {children}
      </div>
    </div>
  </div>
);
